<template>
  <div class="home">
    <vue-scroll
      ref="vs"
      :ops="ops"
      @refresh-start="handleRefreshStart"
      @load-before-deactivate="handleLBD"
      @refresh-before-deactivate="handleRBD"
      @load-start="handleLoadStart"
      @handle-scroll="handleScroll"
    >
      <Tabs v-on:tabchange="tabChange" :currentTab="currentTab" :oprationingPositions="oprationingPositions"></Tabs>
      <template v-if="videoList.length>0">
        <Card v-for="item,index in videoList" :key="index" :item="item" :currentTab="currentTab"></Card>
      </template>
      <template v-else-if="currentTab === 'Live'">
        <div class="home__empty">
          <img src="@/assets/imgs/Home/empty.png">
          <div>{{ $t('message.home.liveEmpty') }}</div>
        </div>
      </template>
    </vue-scroll>
    <div class="home__login global_pointer" @click="gotoProfile">
      <img src="@/assets/imgs/icon-login.png" alt="">
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/Home/tabs.vue';
import Card from '@/components/Home/card.vue';
import { Tabs as tabs } from '@/config/tabs';
import api from "@/api/api_list";

import Oprationing from '@/components/Home/oprationing.vue'

export default {
  name: 'Home',
  data() {
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return {
      ops: {
        vuescroll: {
          mode: isMobile ? 'slide' : 'native',
          sizeStrategy: 'percent',//如果父容器不是固定高度，请设置为 number , 否则保持默认的percent即可
          detectResize: true,//是否检测内容尺寸发生变化
          pullRefresh: {
            enable: true,
            tips: {
              deactive: this.$t('message.home.tips.refresh'),
              active: this.$t('message.home.tips.torefresh'),
              start: this.$t('message.home.tips.refreshing'),
              beforeDeactive: this.$t('message.home.tips.done'),
            },
          },
          pushLoad: {
            enable: true,
            auto: true,
            autoLoadDistance: 10,
            tips: {
              deactive: this.$t('message.home.tips.load'),
              active: this.$t('message.home.tips.toload'),
              start: this.$t('message.home.tips.loading'),
              beforeDeactive: this.$t('message.home.tips.loaded'),
            },
          },
        },
        scrollPanel: {
          initialScrollY: false,//只要组件mounted之后自动滚动的距离。 例如 100 or 10%
          initialScrollX: false,
          scrollingX: false,//是否启用 x 或者 y 方向上的滚动
          scrollingY: true,
          verticalNativeBarPos: 'right'//原生滚动条的位置
        },
        rail: {},
        bar: {
          opacity: 0,
        },
      },
      // 当前选中首页tab，默认Live
      currentTab: 'Live',
      // 页面视频列表
      videoList: [],
      pageNum: 1,
      pageSize: 10,
      isHasNext: 0,
      tabs,
      oprationingPositions: null
    };
  },
  components: {
    Tabs,
    Card,
    Oprationing
  },
  created() {
    // debugger
    let type = this.$route.params.type
    this.currentTab = type || 'Live'
    if(!type){
      this.$router.replace(this.currentTab)
    }
    if (this.$route.params.roomback === 1) {
      let videoList = this.$store.state.video.videoList
      this.videoList = videoList
    } else {
      this.getList(true)
    }
    this.$route.params.roomback = null
  },
  mounted() {
    this.$on('tabChange', this.tabChange);
    this.loadOprationingPosition()
    this.$nextTick(() => {
      let pos = this.$store.state.home.lastPosition
      this.$refs["vs"].scrollTo({y: pos})
    })

  },
  methods: {
    handleRefreshStart(vm, refreshDom, done) {
      this.loadOprationingPosition()
      this.getList(true,done)
    },
    handleLBD(vm, refreshDom, done) {
      setTimeout(() => {
        done();
      }, 1000);
    },
    handleRBD(vm, refreshDom, done) {
      setTimeout(() => {
        done();
      }, 1000);
    },
    handleLoadStart(vm, refreshDom, done) {
      this.getList(false,done)
    },
    handleScroll(vertical, horizontal, nativeEvent) {
      if (this.isMobile) return;
      if (vertical && vertical.process > 0.97) {
        this.getList(false);
        // console.log('加载更多');
      }
    },
    tabChange(data) {
      if(data === this.currentTab){
        return
      }


      this.$router.replace({
        path: './'+data,
        query: this.$route.query
      });

      // this.videoList = []
      // this.currentTab = data;
      // this.getList(true)
    },
    /**
     * @param isClear Boolean 是否清空当前列表
     * @param callback Function 获取数据成功后的回调函数
     */
    getList(isClear,callback){
      console.log('getlist')
      if(isClear){
        this.pageNum = 1
        this.isHasNext = 0
      }else{
        this.pageNum ++
      }
      if(this.isHasNext != 0){
        return
      }
      let liveStatusList = []
      if(this.currentTab === this.tabs.Live.type){ // 直播
        liveStatusList = [2]
      }else if(this.currentTab === this.tabs.Upcoming.type){ // 预告
        liveStatusList = [1]
      }else if(this.currentTab === this.tabs.Replay.type){ // 回放
        liveStatusList = [4]
      }
      api.get_home_list({
        "liveStatusList": liveStatusList,
        "pageNum": this.pageNum,
        "pageSize": this.pageSize
      }).then(res=>{
        if(isClear){
          this.videoList = []
        }
        this.isHasNext = res.result.isHasNext
        this.videoList = this.videoList.concat(res.result.data)
        if(
          !res.result.isHasNext && 
          this.currentTab === this.tabs.Live.type && 
          this.videoList.length === 0 && 
          this.$store.state.home.visitTimes === 0) {
          this.tabChange(this.tabs.Upcoming.type)
          return
        }
        this.$store.commit("home/addVisitTimes", 1);
        callback && callback()
      })
    },
    gotoProfile(){
      this.$router.push({
        path: '../profile', 
        query: this.$route.query
      })
      // this.$login.open()
    },
    gotoRoom(id) {
      const path = `../room/${id}`;
      this.$store.commit("home/updateLastId", id);
      const { scrollTop, scrollLeft } = this.$refs["vs"].getPosition();
      this.$store.commit("home/updateLastPosition", scrollTop);
      this.$router.push({
        path: path,
        query: this.$route.query
      });
    },
     async loadOprationingPosition(){
      await api.operating_position({
        "detailPageSize": 0,
        "pageNum": 0,
        "pageSize": 0,
        "showLocation": [
          1
        ],
      }).then((resp)=>{
        if (resp.code==0&&resp&&resp.result&&resp.result.length>0) {
            let result = resp.result;
            this.oprationingPositions = 
             result.map((a)=>{
              return {type:a.type, name: a.name, icon: a.pictureKey.url, url: a.url, id: a.id}
            }).filter((a)=>{
              return a.type==0&&a.url!=null&&a.url.length>0
            })
        }
      })
    }
  },
  watch: {
    videoList: {
      handler: function(newList) {
        if (!newList || !Array.isArray(newList) || newList.length < 1) return
        this.$store.commit("video/updateVideoList", newList);
        let arr = newList.map(i => i.id)
        this.$store.commit("video/updateList", arr);
        this.$store.commit("home/updateCurrentPage", this.pageNum);
        this.$store.commit("home/updateHasNext", this.isHasNext);
			},
      immediate: true
    },
    currentTab: {
      handler: function(val) {
        this.$store.commit("home/updateLastTab", val);
			},
      immediate: true
    }
  },
  provide() {
    return {
      gotoRoom: this.gotoRoom
    }
  }
};
</script>
<style lang="less">
.home {
  height: calc(100% - 68px);
  background-color: #000000;
  user-select: none;
  &__empty {
    width: 100%;
    margin-top: 90px;
    >img {
      width: 120px;
      height: 107px;
      margin: auto;
    }
    >div {
      display: block;
      max-width: 284px;
      margin: auto;
      margin-top: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
    }
  }
  &__login {
    position: fixed;
    right: 12px;
    bottom: 12px;
    width: 36px;
    height: 36px;
    & img{
      width: 100%;
      height: 100%;
    }
  }
}

.__vuescroll .__refresh,
.__vuescroll .__load {
  color: #ffffff;
}
</style>
